<template>
    <div class="page">
        <header>
            <h1>Nothing to see here.</h1>
            <h2>Don’t worry, we’ll get you back on track.<br>Try searching again.</h2>
        </header>
        <!-- TODO: These images should be put in core CDN. -->
        <img
            alt="Page not found"
            class="img--mobile"
            :src="`${$store.state.imagesCdn}/seats-mobile.png`">
        <img
            alt="Page not found"
            class="img--desktop"
            :src="`${$store.state.imagesCdn}/seats.png`">
    </div>
</template>

<script>
import trackable from '../mixins/Trackable'
import quebecUserModal from '../mixins/QuebecUserModal'

export default {
    beforeCreate () {
        this.htmlPageTitle = `Page Not Found at ${this.$config.partnerName}`
    },
    created () {
        this.trackPageView(this.$route.fullPath, this.htmlPageTitle)
    },
    head: {
        title () {
            return {
                inner: this.htmlPageTitle
            }
        }
    },
    mixins: [
        quebecUserModal,
        trackable
    ]
}
</script>

<style lang="postcss" scoped>
@import 'theme';

h1 {
    color: #1c74a5;
    font-size: 42px;
    font-weight: 500;
    margin: 0 0 10px;
}

h2 {
    font-size: 20px;
    font-weight: normal;
    line-height: 1.4em;
    margin: 0;
}

header {
    margin: 40px var(--site-padding) 20px;
}

img {
    max-width: 100%;

    &.img--desktop {
        display: none;
    }

    &.img--mobile {
        display: block;
        margin-top: auto;
    }
}

.page {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin: 0 auto;
    max-width: 100%;
    min-height: inherit;
    padding: 0;
    width: var(--site-container-width)
}

@media (--mq-large-min) {
    header {
        display: none;
    }

    img {
        &.img--desktop {
            display: block;
        }

        &.img--mobile {
            display: none;
        }
    }

    .page {
        padding: 0 var(--site-padding);
    }
}
</style>
